import { inject, Injectable } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import { TypeEntityTypes } from '@pf/shared-common';
import { ContainerTypesService } from '@control-tower/platform-wms';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';

@Injectable()
export class ContainerTypeFacade extends AbstractTypeEntityFacade<ContainerTypesService> {
    constructor() {
        const typeService = inject(ContainerTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            typeService,
            'containerTypeGetAll',
            TypeEntityTypes.ContainerType
        );
    }
}
